import { roles, typeIntervention } from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import React from "react";
import dayjs from "../../../utils/dayjs";
import { userHasLevel } from "../../../engine/AuthRoute";
import routes from "../../../engine/routes";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { t } from "i18next";

export const prestationInputs = prestation => {
  const {
    intervention: { startDate, endDate, location, extra },
    interventionFinal,
    institution,
    intervenant,
    intervenantFinal,
    intervention,
    applicationAt,
    responsable,
    beneficiary,
    noSharedCost,
    amountBillet,
  } = prestation;

  return [
    {
      parentLabel: "",
      children: [
        {
          required: true,
          label: t("prestationResumeForm.realStartDateTime"),
          name: "interventionFinal.startDate",
          value:
            interventionFinal.startDate === null
              ? dayjs(startDate)
              : dayjs(interventionFinal.startDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          required: true,
          label: t("prestationResumeForm.realEndDateTime"),
          name: "interventionFinal.endDate",
          value:
            interventionFinal.endDate === null
              ? dayjs(endDate)
              : dayjs(interventionFinal.endDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
              [roles.institution]: "r", //
            },
          }),
          label: t("prestationResumeForm.applicationSubmissionDate"),
          name: "applicationAt",
          required: true,
          value: applicationAt === null ? null : dayjs(applicationAt),
          showTime: true,
          type: "date-time",
          col: 12,
        },
        intervention.type === typeIntervention.in_person
          ? {
              required: true,
              label: t("prestationResumeForm.realInterventionAddress"),
              name: "interventionFinal.location",
              value: interventionFinal?.location
                ? interventionFinal.location
                : prestation.intervention.location,
              type: "google-adress",
              col: 24,
            }
          : {},
        {
          label: t("prestationResumeForm.noSharedCost"),
          name: "noSharedCost",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: noSharedCost,
          col: 24,
        },

        intervention.type === typeIntervention.in_person
          ? {
              visible: userHasLevel({
                only: {
                  [roles.admin]: "r", //
                },
              }),
              label: t("prestationResumeForm.realInterpreterDepartureLocation"),
              name: "interventionFinal.locationFrom",
              className: "non-printable",
              value: interventionFinal?.locationFrom
                ? interventionFinal.locationFrom
                : prestation.intervention.locationFrom || "",
              type: "google-adress",
              col: 24,
            }
          : {},
        {
          type: "input-currency",
          name: "amountBillet",
          value: amountBillet,
          label: t("prestationInformations.amountTrain"),
          placeholder: t("prestationInformations.amountTrain"),
          col: 24,
        },
        {
          label: t("prestationResumeForm.billingAddress"),
          name: "billing",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
            },
          }),
          addonBefore: <UserOutlined />,
          quote: (
            <>
              <p>{t("prestationResumeForm.editOnInstitutionPage")}</p>
              <a
                target={"_blank"}
                href={
                  routes.institutions(prestation?.institution?._id).addresses
                    .path
                }
              >
                {t("prestationResumeForm.editAddresses")}
              </a>
            </>
          ),
          quoteIcon: "info",
          type: "dynamic-select",
          required: true,
          value: prestation.billing === null ? null : prestation.billing._id,
          multiple: false,
          endPoint: `addresses?institution=${prestation?.institution?._id}&type=${typeAddress.postal}`,
          itemsCallBack: addresses => {},
          inputSize: "large",
          noSorting: true,
          itemCallback: adress => {
            return {
              key: adress._id,
              label: renderAdress(
                adress,
                prestation?.institution?.defaultAddress === adress._id,
                prestation?.institution,
              ),
              value: adress._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationResumeForm.beneficiaryReferenceInfo"),
      description: t("prestationResumeForm.beneficiaryInfoDescription"),
      children: [
        {
          label: t("prestationResumeForm.beneficiaryReference"),
          name: "beneficiary.reference",
          type: "input",
          col: 24,
        },
        {
          label: t("prestationResumeForm.beneficiaryLastName"),
          name: "beneficiary.firstname",
          type: "input",
          visible:
            beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
        {
          label: t("prestationResumeForm.beneficiaryFirstName"),
          name: "beneficiary.lastname",
          type: "input",
          visible:
            beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationResumeForm.interviewResponsiblePersonnel"),
      children: [
        {
          placeholder: t("prestationResumeForm.lastName"),
          value: responsable?.lastname,
          name: "responsable.lastname",
          type: "input",
          required: true,
          addonBefore: <UserOutlined />,
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.firstName"),
          value: responsable?.firstname,
          name: "responsable.firstname",
          required: true,
          addonBefore: <UserOutlined />,
          type: "input",
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.email"),
          value: responsable?.email,
          name: "responsable.email",
          addonBefore: <HiOutlineMail />,
          type: "input",
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.phone"),
          value: responsable?.phone,
          name: "responsable.phone",
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 12,
        },
        {
          label: t("prestationResumeForm.remark"),
          name: "interventionFinal.note",
          addonBefore: <HiOutlineMail />,
          placeholder: t("prestationResumeForm.remark"),
          type: "textarea",
          col: 24,
        },
      ],
    },
  ];
};
